module.exports = __webpack_public_path__ + "static/media/template_img.7907cd81.png";